<template>
  <b-tabs content-class="mt-4" nav-wrapper-class="switching-tabs">
    <b-tab title="My Wallet" active>
      <div class="row">
        <div class="col-md-7 mb-5">
          <small class="d-block mb-2">Your Current Balance</small>
          <div class="font-weight-bold h3 mb-4">{{walletAmount}}</div>
          <!-- <form>
            <input type="text" placeholder="Enter amount to be added in wallet" name="" id="">
            <br>
            <button class="btn-gogo mw-250 mt-4" disabled>Add Money to Wallet</button>
          </form> -->
        </div>
        <div class="col-md-5 mb-5">
          <div class="d-flex border-bottom pb-2 mb-4">
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23.1429 22H3.42857C1.53771 22 0 20.4303 0 18.5V1.875C0 1.392 0.384 1 0.857143 1C1.33029 1 1.71429 1.392 1.71429 1.875V18.5C1.71429 19.466 2.484 20.25 3.42857 20.25H22.2857V3.625C22.2857 3.142 22.6697 2.75 23.1429 2.75C23.616 2.75 24 3.142 24 3.625V21.125C24 21.608 23.616 22 23.1429 22Z"
                fill="#E70D01" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2.59091 5H18.1364C18.6131 5 19 4.62667 19 4.16667V0.833333C19 0.373333 18.6131 0 18.1364 0H2.59091C1.16245 0 0 1.12167 0 2.5C0 3.87833 1.16245 5 2.59091 5ZM2 2C2 1.448 2.37333 1 2.83333 1H17V3H2.83333C2.37333 3 2 2.552 2 2Z"
                fill="#E70D01" />
              <path
                d="M23.125 5H17.875C17.392 5 17 4.552 17 4C17 3.448 17.392 3 17.875 3H23.125C23.608 3 24 3.448 24 4C24 4.552 23.608 5 23.125 5Z"
                fill="#E70D01" />
              <path
                d="M23.1 15H17.7C16.2114 15 15 13.8783 15 12.5C15 11.1217 16.2114 10 17.7 10H23.1C23.5968 10 24 10.3733 24 10.8333C24 11.2933 23.5968 11.6667 23.1 11.6667H17.7C17.205 11.6667 16.8 12.0417 16.8 12.5C16.8 12.9583 17.205 13.3333 17.7 13.3333H23.1C23.5968 13.3333 24 13.7067 24 14.1667C24 14.6267 23.5968 15 23.1 15Z"
                fill="#E70D01" />
            </svg>
            <div class="pl-2">Why use the Gogo Walllet you ask?</div>
          </div>
          <ul class="pl-4">
            <li class="mb-1">Quick and Easy Chechkout.</li>
            <li class="mb-1">Recive instant refunds directly to your account.</li>
            <li class="mb-1">Get exclusive Offers and Discounts.</li>
          </ul>
        </div>
      </div>

    </b-tab>

    <b-tab title="Transfers">
      <div class="row">
        <div class="col-md-7 mb-5">
          <form @submit.prevent="validateBeforeSubmit('transfer')" data-vv-scope="transfer">
            <input v-model="user.email" type="text" placeholder="Enter your friend's email id">
            <!-- <small class="d-block mt-2 text-success font-italic">Email Id registered as sam@gmail.com</small> -->
            <small class="d-block mt-1 font-italic mt-2">(Please note your friend must be a registered user with Gogo
              Cinema.)</small>
            <br>
            <input v-model="user.amount" type="number" placeholder="Enter amount to be transferred" name="" id="">
            <small class="d-block mt-2 text-danger font-italic">{{errorMessage}}</small>
            <small class="d-block mt-2 text-success font-italic">{{successMessage}}</small>
            <!-- <div v-b-toggle="'personalMessage'" class="text-primary small c-pointer my-3 d-table">Add a personal message
            </div> -->
            <b-collapse id="personalMessage">
              <textarea placeholder="Your personal message starts here" cols="5" rows="5"></textarea>
            </b-collapse>
            <button @click.native="transferFund()" class="btn-gogo mw-250 mt-4">Send Money</button>
          </form>
        </div>

        <!-- Verify Your OTP Modal-->

              <div class="verify-otp">
                <!-- <b-button v-b-modal.otp>Verify otp</b-button> -->

                <!-- Modal Component -->
                <b-modal ref="OTPModal" id="otp" title="Verify Your Contact Detail">
                  <form @submit.prevent="validateBeforeSubmit('verifyOTP')" data-vv-scope="verifyOTP">
                    <div class="p-5">
                      <p class="otp-text text-center mb-0">Almost there! Please enter the 4 digit verification code you
                        might have just received via email / SMS.</p>
                      {{errorMessage.otp}}
                      <div class="my-4 otp-section">
                        <div class="form-row">
                          <div class="d-flex otp-mob mx-auto">
                            <div class="col px-2 px-md-1">
                              <input type="number" id="otp1" btnNumber="1" class="form-control text-center py-4"
                                placeholder maxlength="1" pattern="([12345])\w{0}" v-model="user.OTP[0]"
                                v-on:keyup="OTPonKeyUp(0, $event)" ref="otp1">
                            </div>
                            <div class="col px-2 px-md-1">
                              <input type="number" id="otp2" class="form-control text-center py-4" placeholder
                                maxlength="1" pattern="([12345])\w{0}" v-model="user.OTP[1]"
                                v-on:keyup="OTPonKeyUp(1, $event)" ref="otp2">
                            </div>
                            <div class="col px-2 px-md-1">
                              <input type="number" id="otp2" class="form-control text-center py-4" placeholder
                                maxlength="1" pattern="([12345])\w{0}" v-model="user.OTP[2]" ref="otp3"
                                v-on:keyup="OTPonKeyUp(2, $event)">
                            </div>
                            <div class="col px-2 px-md-1">
                              <input type="number" id="otp2" class="form-control text-center py-4" placeholder
                                maxlength="1" pattern="([12345])\w{0}" ref="otp4" v-on:keyup="OTPonKeyUp(3, $event)"
                                v-model="user.OTP[3]">
                            </div>
                          </div>
                        </div>

                      </div>
                      <p class="grey-text text-center mb-4">
                        Haven't received it yet?
                        <router-link @click.native="verifyOTP()" to="#">Resend code</router-link>
                      </p>
                      <div>
                        <input type="submit" class="gogo-btn btn btn-danger" value="Confirm your details" />
                      </div>
                    </div>
                  </form>
                </b-modal>
              </div>

        <!-- <div class="col-md-5 mb-5">
          <div class="border-bottom pb-2 mb-4 font-weight-bold">Recents</div>
          <div class="row mx-0">
            <div class="recent-profiles" v-for="(wallet , walletkey) in walletsDetails" v-if="wallet.Type == 'TRANSFERRED'" :key="walletkey"> -->
              <!-- <img src="@/assets/img/profile.png" alt=""> -->
              <!-- <div>{{wallet.Title}}</div>
            </div>
          </div>
        </div> -->

      </div>
    </b-tab>

    <b-tab title="Wallet Log">
      <div class="walletLog-container" v-for="(wallet , key) in walletsDetails" :key="key">
        <div class="d-flex flex-wrap">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 py-3 pr-xl-0 jm-mobile">
            <div class="row">
              <div
                class="col-3 col-sm-2 col-md-2 col-lg-3 col-xl-3 d-flex text-center text-md-left flex-column justify-content-center flex-lg-row justify-content-lg-start">
                <div>
                  <img width="40px" v-if="wallet.Status === 'Successfully'" src="@/assets/img/svg/gc-success-logo.png" alt="">                  
                  <img v-else-if="wallet.Status !== 'Successfully'" rc="@/assets/img/svg/gc-add.svg" alt="">
                </div>

                <div class="ml-2 d-none d-lg-block">
                  <div class="tiny text-muted">GoGo Cash</div>
                  <!-- <div v-if="wallet.Type == 'TRANSFERRED'">Added</div> -->
                  <div class="small text-muted">{{wallet.Type}}</div>
                </div>

                <div class="small text-muted mt-2 d-lg-none">Used</div>
              </div>
              <div class="col-9 col-sm-10 col-md-10 col-lg-9 col-xl-9">
                <div class="row">
                  <div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-4 pl-0 mb-2 mb-xl-0">
                    <div v-if="wallet.Type == 'USED'" class="tiny text-muted">For</div>
                    <div v-if="wallet.Type == 'TRANSFERRED'" class="tiny text-muted">To</div>
                    <div>{{wallet.Title}}</div>
                  </div>
                  <div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl pl-0 mb-2 mb-xl-0">
                    <div class="tiny text-muted pl-0">Amount</div>
                    <div>{{Currency}} {{wallet.Amount}}</div>
                  </div>
                  <div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl pl-0">
                    <div class="tiny text-muted">Status</div>
                    <div>{{wallet.Status}}</div>
                  </div>
                  <!-- <div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl pl-0">
                    <div class="tiny text-muted pl-0">Comment</div>
                    <div class="text-truncate">{{wallet.Comment}}</div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-12 col-xl-2 d-flex justify-content-between align-items-center flex-xl-column flex-xl-column-reverse align-items-xl-end py-2 py-lg-3">
            <div class="small text-muted">
              <span>{{wallet.Date}}</span>
              <!-- <span>|</span> -->
              <!-- <span>01:30 PM</span> -->
            </div>
            <div class="small text-muted">Transaction Id : {{wallet.ID}}</div>
          </div>
        </div>
      </div>
    </b-tab>
  </b-tabs>


</template>

<script>
import { makeRequest } from "@/helper/internet.js";
import { TokenService } from "@/services/storage.service";
export default {
  data() {
    return {
      walletsDetails: [],
      recentProfiles: [],
      walletAmount: "",
      errorMessage: "",
      successMessage: "",
      user: {
        email: "",
        amount: "",
        OTP: ["", "", "", ""]
      },
      Currency: "",
      TransactionID: ""
    };
  },
  beforeMount() {
    this.fetchNotifications();
  },
  methods: {
    OTPonKeyUp: function(item, e) {
      if (this.user.OTP[item].length > 1) {
        this.user.OTP[item] = this.user.OTP[item][this.user.OTP[item].length];
      }
      if (e.keyCode < 58 && e.keyCode > 47) {
        let value = "otp" + (item + 2);
        this.$refs[value].focus();
      }
    },
    fetchNotifications: function() {
      let token = TokenService.getToken();
      makeRequest("/Payment/GetWalletInfo", "POST", token, null)
        .then(result => {
          this.walletsDetails = result.res.data.Data.Log;
          this.walletAmount =
            result.res.data.Currency + " " + result.res.data.Amount;
          this.Currency = result.res.data.Currency;
        })
        .catch(error => {
          console.log("Error", error);
        });
    },

    validateBeforeSubmit(scope) {
      if (scope == "transfer") {
        let token = TokenService.getToken();
        let payload = { Email: this.user.email, Amount: this.user.amount };
        makeRequest("/Payment/WalletTransfer", "POST", token, payload)
          .then(result => {
            if (result.res.data.Status) {
              this.$refs.OTPModal.show();
              this.TransactionID = result.res.data.TransactionID;
            } else {
              this.errorMessage = result.res.data.Message;
              this.successMessage = "";
            }
          })
          .catch(error => {
            console.log("Error", error);
          });
        return;
      }
      if (scope == "verifyOTP") {
        let token = TokenService.getToken();
        let payload = {
          Email: this.user.email,
          Amount: this.user.amount,
          TransactionID: this.TransactionID,
          OTP: this.user.OTP.toString().replace(/,/g, "")
        };
        makeRequest("/Payment/WalletTransfer", "POST", token, payload)
          .then(result => {
            if (result.res.data.Status) {
              this.$refs.OTPModal.hide();
              this.successMessage = result.res.data.Message;
              this.errorMessage = "";
            } else {
              this.$refs.OTPModal.hide();
              this.successMessage = "";
              this.errorMessage = result.res.data.Message;
            }
          })
          .catch(error => {
            console.log("Error", error);
          });
      }
    },

    verifyOTP(data) {}
  }
};
</script>

<style>
.tiny {
  font-size: 10px;
}

.walletLog-container {
  overflow: hidden;
  border-radius: 7px;
  margin-bottom: 20px;
  border-color: #fff;
  border: 1px solid #8d99af;
}

.c-pointer {
  cursor: pointer;
}

.recent-profiles {
  width: 100%;
  cursor: pointer;
  max-width: 110px;
  text-align: center;
  margin-bottom: 30px;
}

.recent-profiles img {
  width: 95px;
  height: 95px;
  border-radius: 50%;
  margin-bottom: 10px;
}

.mw-250 {
  max-width: 250px !important;
}

.mw-500 {
  max-width: 500px;
}

@media (max-width: 1199px) {
  .walletLog-container {
    border-radius: 10px;
  }

  .jm-mobile {
    background-color: #edf2f4;
    border-radius: 10px;
    border-bottom: 1px solid #8d99af;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/myWallet.vue